const equipmentsRegistrationLimitWarning = {
  limitPercentage: {
    'appBar': 'Limite de equipamentos em {{percentage}}%',
    'sideBar': '{{percentage}}% do limite de equipamentos',
    'table': '{{percentage}}% do limite de equipamentos',
  },
  registeredEquipments: 'Equipamentos cadastrados',
  contactAccountables: 'Enviar email',
  reachedInfoPrefix: 'Você atingiu',
  reachedInfoSuffix: 'do limite de equipamentos do seu plano',
  reachedInfoText: 'faça um upgrade para continuar cadastrando',
  notificationSuccessTitle: 'Notificação enviada',
  notificationSuccessText: 'Os responsáveis foram notificados com sucesso.',
  notificationErrorTitle: 'Erro ao enviar notificação',
  notificationErrorText: 'Não foi possível enviar a notificação para os responsáveis. Tente novamente.',
  upgradeInfo: 'para cadastrar mais equipamentos será necessário um upgrade. Clique em "Enviar Email" ou envie um e-mail para os seguintes responsáveis GAP',
  noAccountables: 'Não possui responsáveis',
  modalTitle: 'Limite de equipamentos',
  messageSentTitle: 'Mensagem enviada!',
  messageSentText: 'Logo um de nossos consultores entrará em contato.',
};

export default equipmentsRegistrationLimitWarning;
